<template>
  <Modal :value="value" @input="close">
    <div slot="header">
      Exportar motoristas (XLSX)
    </div>

    <div>
      <p class="mb-3">{{ description }}</p>

      <div class="d-flex justify-content-between align-items-center mb-2">
        <small class="text-muted">{{ selected.length }} de {{ columns.length }} colunas selecionadas</small>
        <div>
          <button class="btn btn-link btn-sm" type="button" :disabled="busy" @click="toggleAll">
            {{ allSelected ? 'Desmarcar todas' : 'Marcar todas' }}
          </button>
          <button class="btn btn-link btn-sm" type="button" :disabled="busy" @click="restoreDefault">
            Restaurar padrão
          </button>
        </div>
      </div>

      <div class="row">
        <div v-for="column in columns" :key="column.id" class="col-md-6">
          <div class="form-check mb-2">
            <input class="form-check-input" type="checkbox" :id="`driver-report-column-${column.id}`"
              :value="column.id" v-model="selected" :disabled="busy">
            <label class="form-check-label" :for="`driver-report-column-${column.id}`">
              {{ column.label }}
            </label>
          </div>
        </div>
      </div>

      <small v-if="selected.length === 0" class="text-danger d-block mt-2">
        Selecione ao menos uma coluna para exportar.
      </small>
      <small v-else class="text-muted d-block mt-2">
        Até 10 motoristas o arquivo é baixado na hora. Acima disso, ele é gerado em segundo plano e o link chega
        por notificação e e-mail.
      </small>
    </div>

    <div slot="footer">
      <button class="btn btn-outline mr-2" type="button" :disabled="busy" @click="close">Cancelar</button>
      <button class="btn btn-primary" type="button" :disabled="busy || selected.length === 0" @click="confirm">
        {{ busy ? 'Exportando...' : 'Exportar XLSX' }}
      </button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/shares/specialTag/Modal'

const COLUMNS = [
  { id: 'id', label: 'ID', selected: true },
  { id: 'name', label: 'Nome', selected: true },
  { id: 'cpf', label: 'CPF', selected: true },
  { id: 'phone', label: 'Telefone', selected: true },
  { id: 'category', label: 'Categoria', selected: true },
  { id: 'account_name', label: 'Nome da Conta', selected: true },
  { id: 'account_id', label: 'ID da Conta', selected: false },
  { id: 'cnh_number', label: 'Nº CNH', selected: false },
  { id: 'cnh_category', label: 'Categoria CNH', selected: false },
  { id: 'cnh_issue_date', label: 'Emissão CNH', selected: false },
  { id: 'cnh_expiration_date', label: 'Validade CNH', selected: false },
  { id: 'cnh_status', label: 'Status CNH', selected: false },
  { id: 'toxicological_expiration_date', label: 'Validade toxicológico', selected: false },
  { id: 'toxicological_status', label: 'Status toxicológico', selected: false },
  { id: 'cnh_file_attached', label: 'CNH anexada', selected: false },
  { id: 'created_by', label: 'Criado por', selected: true },
  { id: 'updated_by', label: 'Atualizado por', selected: true },
  { id: 'created_at', label: 'Criado em', selected: true },
  { id: 'updated_at', label: 'Atualizado em', selected: true }
]

const DEFAULT_COLUMNS = COLUMNS.filter(column => column.selected).map(column => column.id)

export default {
  name: 'ReportColumnsModal',
  components: { Modal },
  props: {
    value: { type: Boolean, default: false },
    description: { type: String, default: '' },
    busy: { type: Boolean, default: false }
  },
  data: () => ({
    columns: COLUMNS,
    selected: [...DEFAULT_COLUMNS]
  }),
  computed: {
    allSelected() {
      return this.selected.length === this.columns.length
    },
    orderedSelection() {
      return this.columns.filter(column => this.selected.includes(column.id)).map(column => column.id)
    }
  },
  methods: {
    close() {
      if (this.busy) return

      this.$emit('input', false)
    },
    confirm() {
      if (this.orderedSelection.length === 0) return

      this.$emit('export', this.orderedSelection)
    },
    restoreDefault() {
      this.selected = [...DEFAULT_COLUMNS]
    },
    toggleAll() {
      this.selected = this.allSelected ? [] : this.columns.map(column => column.id)
    }
  }
}
</script>
